import { Box } from '@mui/material';

export const Pharmacy = () => {
    return <Box sx={{ flex: 1 }}></Box>;
};
